export default __webpack_public_path__ + "static/media/05.8f14b895.png";